import React from 'react'
import './Footer.css';

const Footer = () => {
  return (
    <div className='box-footer'>
      <div className="line-footer"></div>
    </div>
  );
}

export default Footer
